import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

interface ContactFieldRowProps {
  readonly label: string;
  readonly value?: string | null;
}

const styles = StyleSheet.create({
  row: {
    height: 72,
    justifyContent: 'center',
    paddingHorizontal: 16,
  },
  label: {
    color: '#254157',
    fontSize: 12,
    letterSpacing: 0.4,
    lineHeight: 16,
  },
  value: {
    color: '#17344a',
    fontSize: 16,
    letterSpacing: 0.5,
    lineHeight: 24,
  },
});

export const ContactFieldRow = ({ label, value }: ContactFieldRowProps) => (
  <View style={styles.row}>
    <Text style={styles.label}>{label}</Text>
    <Text style={styles.value}>{value ?? '—'}</Text>
  </View>
);
